import { render, staticRenderFns } from "./LangButtonsSeparate.vue?vue&type=template&id=17485a94&scoped=true"
import script from "./LangButtonsSeparate.vue?vue&type=script&lang=js"
export * from "./LangButtonsSeparate.vue?vue&type=script&lang=js"
import style0 from "./LangButtonsSeparate.vue?vue&type=style&index=0&id=17485a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17485a94",
  null
  
)

export default component.exports